import React from 'react';
import { Box } from '@mui/material';
import {
  FOG_800M_COLOR,
  FOG_1600M_COLOR,
  FOG_3000M_COLOR,
  NO_FOG_COLOR,
  NO_DATA_COLOR
} from '../../theme/colors';
import * as styles from '../../styles/MapPageStyles';
import { Airport } from '../../data/locations';
import { AirportStatus } from '../../services/FogStatusCalculator';

interface MapTooltipProps {
  tooltipContent: {
    x: number;
    y: number;
    airport: Airport;
  } | null;
  airportStatuses: Record<number, AirportStatus>;
  formatVisibility: (value: number) => string;
}

const MapTooltip: React.FC<MapTooltipProps> = ({
  tooltipContent,
  airportStatuses,
  formatVisibility
}) => {
  if (!tooltipContent) return null;

  const getVisibilityText = (color: string | undefined) => {
    switch (color) {
      case FOG_800M_COLOR:
        return `≤ ${formatVisibility(800)}`;
      case FOG_1600M_COLOR:
        return `≤ ${formatVisibility(1600)}`;
      case FOG_3000M_COLOR:
        return `≤ ${formatVisibility(3000)}`;
      case NO_FOG_COLOR:
        return '> 3000 m';
      default:
        return 'No Data';
    }
  };

  return (
    <Box sx={styles.getTooltipStyles(tooltipContent.x, tooltipContent.y)}>
      <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
        {tooltipContent.airport.name} ({tooltipContent.airport.code})
      </div>
      <div style={{ fontSize: '11px', opacity: 0.9 }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}>
          <span style={{ width: '60px' }}>Current:</span>
          <Box sx={styles.tooltipColorBoxStyles(
            airportStatuses[tooltipContent.airport.id]?.actualColor || NO_DATA_COLOR
          )} />
          <span style={{ fontWeight: '500' }}>
            {getVisibilityText(airportStatuses[tooltipContent.airport.id]?.actualColor)}
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ width: '60px' }}>Forecast:</span>
          <Box sx={styles.tooltipColorBoxStyles(
            airportStatuses[tooltipContent.airport.id]?.forecastColor || NO_DATA_COLOR
          )} />
          <span style={{ fontWeight: '500' }}>
            {getVisibilityText(airportStatuses[tooltipContent.airport.id]?.forecastColor)}
          </span>
        </div>
      </div>
    </Box>
  );
};

export default MapTooltip;